import { useEffect, useState } from 'react';
import {
	BrowserRouter as Router,
	Route,
	Routes,
	Link,
	useLocation,
} from 'react-router-dom';

import GlobalStyle from './components/styles/GlobalStyle';
import WhitepaperPage from './components/WhitepaperPage';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import ExploreDataPage from './components/ExploreDataPage';
import ProjectPage from './components/ProjectPage';
import ProjectsHubPage from './components/ProjectsHubPage';
import ProjectPlaceholderPage from './components/ProjectPlaceholderPage';
import MethodologyPage from './components/MethodologyPage';
import TulsaHeatmap from './components/TulsaHeatmap';
import DataBrowserPage from './components/DataBrowserPage';
import AccessRequestsTab from './components/AccessRequestsTab';
import VestigaLandingPage from './components/VestigaLandingPage';
import { Navigate } from 'react-router-dom';

const C = {
	teal: '#1A7A6E',
	tealLight: '#2BA898',
	tealDark: '#0F5048',
	green: '#6DBF67',
	bg: '#F7F5F0',
	bgDark: '#0E1A18',
	paper: '#FDFBF7',
	ink: '#1C1C1C',
	inkMid: '#3D3D3D',
	inkSoft: '#6B6B6B',
	rule: '#D8D2C8',
};

const NAV_LINKS = [
	{ to: '/', label: 'Home' },
	{ to: '/projects', label: 'Projects' },
	{ to: '/methodology', label: 'Methodology' },
	{ to: '/explore', label: 'Explore Data' },
	{ to: '/about', label: 'About' },
];

function useBreakpoint() {
	const [width, setWidth] = useState(
		typeof window !== 'undefined' ? window.innerWidth : 1200,
	);
	useEffect(() => {
		const fn = () => setWidth(window.innerWidth);
		window.addEventListener('resize', fn);
		return () => window.removeEventListener('resize', fn);
	}, []);
	const isMobile = width < 640;
	const isTablet = width >= 640 && width < 1024;
	const isDesktop = width >= 1024;
	const px = isMobile ? '20px' : isTablet ? '40px' : '80px';
	return { width, isMobile, isTablet, isDesktop, px };
}

function ScrollToTop() {
	const { pathname } = useLocation();
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);
	return null;
}

function AppShell() {
	const location = useLocation();
	const isVestiga = location.pathname === '/vestiga';
	return (
		<>
			{!isVestiga && (
				<Navbar
					C={C}
					Link={Link}
					useLocation={useLocation}
					useBreakpoint={useBreakpoint}
					NAV_LINKS={NAV_LINKS}
				/>
			)}
			<main>
				<Routes>
					<Route path='/vestiga' element={<VestigaLandingPage />} />
					<Route
						path='/'
						element={
							<HomePage C={C} Link={Link} useBreakpoint={useBreakpoint} />
						}
					/>
					{/* Legacy redirect */}
					<Route path='/project' element={<Navigate to='/projects/tulsa' replace />} />

					{/* Projects hub + individual project pages */}
					<Route
						path='/projects'
						element={
							<ProjectsHubPage C={C} Link={Link} useBreakpoint={useBreakpoint} />
						}
					/>
					<Route
						path='/projects/tulsa'
						element={
							<ProjectPage C={C} Link={Link} useBreakpoint={useBreakpoint} />
						}
					/>
					<Route
						path='/projects/tulsa/explore'
						element={
							<ExploreDataPage C={C} useBreakpoint={useBreakpoint} Link={Link} />
						}
					/>
					<Route
						path='/projects/tulsa/heatmap'
						element={<TulsaHeatmap C={C} useBreakpoint={useBreakpoint} />}
					/>
					<Route
						path='/projects/elaine'
						element={
							<ProjectPlaceholderPage
								projectId='elaine'
								C={C}
								Link={Link}
								useBreakpoint={useBreakpoint}
							/>
						}
					/>
					<Route
						path='/projects/rosewood'
						element={
							<ProjectPlaceholderPage
								projectId='rosewood'
								C={C}
								Link={Link}
								useBreakpoint={useBreakpoint}
							/>
						}
					/>

					<Route
						path='/methodology'
						element={<MethodologyPage C={C} useBreakpoint={useBreakpoint} />}
					/>
					<Route
						path='/explore'
						element={
							<ExploreDataPage
								C={C}
								useBreakpoint={useBreakpoint}
								Link={Link}
							/>
						}
					/>
					<Route
						path='/about'
						element={<AboutPage C={C} useBreakpoint={useBreakpoint} />}
					/>
					<Route
						path='/whitepaper'
						element={<WhitepaperPage C={C} useBreakpoint={useBreakpoint} />}
					/>
					<Route
						path='/heatmap'
						element={<TulsaHeatmap C={C} useBreakpoint={useBreakpoint} />}
					/>
					<Route
						path='/browser'
						element={<DataBrowserPage C={C} useBreakpoint={useBreakpoint} />}
					/>
					<Route
						path='/admin/requests'
						element={
							<AccessRequestsTab C={C} useBreakpoint={useBreakpoint} />
						}
					/>
				</Routes>
			</main>
			{!isVestiga && <Footer C={C} useBreakpoint={useBreakpoint} NAV_LINKS={NAV_LINKS} />}
		</>
	);
}

export default function App() {
	return (
		<>
			<GlobalStyle C={C} />
			<Router>
				<ScrollToTop />
				<AppShell />
			</Router>
		</>
	);
}
